import PropTypes from 'prop-types';
import classNames from 'classnames';

import withLoading from './withLoading';

import './SliderTrackFloorPlan.scss';

const noop = () => {};

const SliderTrackFloorPlan = ({
  item,
  hasPlaceholder = false,
  loadingClassName = '',
  handleLoad = noop
}) => {
  const className = classNames('slider-floorplan', {
    [loadingClassName]: hasPlaceholder
  });

  return (
    <div className={className}>
      <img
        className="slider-floorplan__image"
        src={item.src}
        alt={item.caption}
        onLoad={handleLoad}
      />
    </div>
  );
};

SliderTrackFloorPlan.propTypes = {
  item: PropTypes.shape({
    src: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired
  }).isRequired,
  hasPlaceholder: PropTypes.bool,
  loadingClassName: PropTypes.string,
  handleLoad: PropTypes.func
};

export default withLoading({ loadingClassName: 'slider-floorplan--hidden' })(
  SliderTrackFloorPlan
);
